import React from 'react';

import DemandRatesTable from '../components/tables/DemandRatesTable';

const SettingsDemandRatesPage: React.FC = () => <DemandRatesTable />;

export default SettingsDemandRatesPage;
